(() => {
  if (customElements.get('fxl-extras-collections')) return;
  customElements.define('fxl-extras-collections', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const seen = new Set();
      this.querySelectorAll('[data-fxl-extra-group]').forEach(group => {
        if (seen.has(group.dataset.url)) group.remove();
        else seen.add(group.dataset.url);
      });
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.load();
        }
      }, {rootMargin: '300px'});
      this.observer.observe(this);
      this.onCart = () => this.filter();
      document.addEventListener('cart:updated', this.onCart);
    }
    async load() {
      let cart;
      try {
        const response = await fetch(this.dataset.root + 'cart.js', {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(10000)});
        if (response.ok) cart = await response.json();
      } catch {}
      this.cartIds = new Set((cart?.items || []).map(item => String(item.product_id)));
      this.groups = [];
      for (const group of this.querySelectorAll('[data-fxl-extra-group]')) {
        if (!this.isConnected) return;
        try {
          const url = new URL(group.dataset.url, location.origin);
          url.searchParams.set('view', 'fxl-extras');
          url.searchParams.set('sort_by', 'best-selling');
          const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(15000)});
          if (!response.ok) continue;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = doc.querySelector('[data-fxl-extras-response][data-sort="best-selling"]');
          const list = payload?.querySelector('[data-fxl-extras-cards]');
          if (!list) continue;
          const cards = [...list.children].filter(card => card.matches('[data-product-id]'));
          this.groups.push({group, list, cards});
          group.querySelector('[data-fxl-extra-products]').replaceChildren(list);
          this.filter();
        } catch {}
      }
    }
    filter() {
      const cart = window.FXLCartPage?.state || window.FXLCartDrawer?.state;
      if (cart?.items) this.cartIds = new Set(cart.items.map(item => String(item.productId)));
      const excluded = new Set([...(this.cartIds || []), this.dataset.productId]);
      const limit = Math.min(20, Math.max(2, Number(this.dataset.limit) || 8));
      for (const {list, cards} of this.groups || []) {
        const selected = cards.filter(card => !excluded.has(card.dataset.productId)).slice(0, limit);
        selected.forEach(card => excluded.add(card.dataset.productId));
        list.replaceChildren(...selected);
        list.hidden = !selected.length;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('cart:updated', this.onCart);
    }
  });
})();
